import { useEffect, useRef } from "react";

/**
 * useEffect that runs exactly once per component instance, even under React
 * StrictMode double-invoke in development. Prevents duplicate analytics events.
 */
export function useOnce(effect) {
  const ranRef = useRef(false);
  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
